// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__J19En","upload":"Small_upload__i_Vm8","imageWrap":"Small_imageWrap__3QueZ","removeBtn":"Small_removeBtn__1rGvF"};